// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1x8hT","title":"card_title__BEkh6","inActive":"card_inActive__2OJiL"};